import { useState, useCallback } from "react";

const useHistory = (initialState) => {
  const [history, setHistory] = useState({
    past: [],
    present: initialState,
    future: []
  });

  // 1. 取得當前狀態
  const state = history.present;

  // 2. 設定新狀態 (相當於原本的 setState)
  // 這會把「現在」推入「過去」，並設定「新的現在」，清空「未來」
  const set = useCallback((newState) => {
    setHistory((curr) => {
      // 支援 functional update，例如 setPages(prev => ...)
      const nextState = typeof newState === 'function' 
        ? newState(curr.present) 
        : newState;

      if (nextState === curr.present) return curr; // 如果沒變就不紀錄

      return {
        past: [...curr.past, curr.present],
        present: nextState,
        future: [] // 一旦有新動作，未來就失效了
      };
    });
  }, []);

  // 3. 復原 (Undo)
  const undo = useCallback(() => {
    setHistory((curr) => {
      if (curr.past.length === 0) return curr;

      const previous = curr.past[curr.past.length - 1];
      const newPast = curr.past.slice(0, curr.past.length - 1);

      return {
        past: newPast,
        present: previous,
        future: [curr.present, ...curr.future]
      };
    });
  }, []);

  // 4. 重做 (Redo) - 既然做了 Undo，通常也會順便做 Redo
  const redo = useCallback(() => {
    setHistory((curr) => {
      if (curr.future.length === 0) return curr;

      const next = curr.future[0];
      const newFuture = curr.future.slice(1);

      return {
        past: [...curr.past, curr.present],
        present: next,
        future: newFuture
      };
    });
  }, []);

  return {
    state,
    set,
    undo,
    redo,
    canUndo: history.past.length > 0,
    canRedo: history.future.length > 0,
    history // 除錯用
  };
};

export default useHistory;